<div class="page-content">
    <div class="body-data">
        <div class="main">
            <div class="heading">
                <div class="h6">
                    <span class="text-heading">Tickets</span>
                    <div class="button">
                        <button class="bor-orange" (click)="gotonewticket()">Create Ticket</button>
                    </div>
                </div>

            </div>
            <div class="clsnotify">
                <div class="cls-leftside">
                    <!-- <div class="cls-show-check form-group col-md-3 pl-0"> 
                        <label class="inner clscheck">
                        <input type="checkbox" name="checkbox"  checked="checked">All Tickets
                        <span class="checkmark"></span> 
                        </label>
                    </div> -->
                    <div class="cls-show-check form-group col-md-3 pl-0">
                        <label class="inner clscheck">
                            <input type="checkbox" (click)="filterByOpenTicketType($event)" name="checkbox" value="open"
                                checked="checked">Open Tickets
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="cls-show-check form-group col-md-3 pl-0">
                        <label class="inner clscheck">
                            <input type="checkbox" (click)="filterByCloseTicketType($event)" name="checkbox"
                                value="close" checked="checked">Closed Tickets
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
                <div class="cls-rightside">
                    <div class="form-group no-mar col-md-7">
                        <div class="dropdown arrow-img">

                            <button class="btn dropdown-toggle " type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Ticket category
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <label class="inner clscheck">
                                    <input type="checkbox" (click)="filterByCustomerCatType($event)" name="checkbox"
                                        value="customer" checked="checked">Technical Support
                                    <span class="checkmark"></span>
                                </label>
                                <label class="inner clscheck">
                                    <input type="checkbox" (click)="filterByPartnerCatType($event)" name="checkbox"
                                        value="partner" checked="checked">Partner Order
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="cls-search col-md-5 pr-0">
                        <div class="input-group" style="right: 10px; width: 116%;">
                            <input class="form-control py-2 border-right-0 border" [(ngModel)]="searchTicketNo"
                                (keydown.enter)="getTicketList()" type="search" placeholder="Search By Ticket No"
                                id="example-search-input">
                            <span class="input-group-append">
                                <button (click)="getTicketList()" class="btn btn-outline-secondary border-left-0 border"
                                    type="button">
                                    <i class="fa fa-search"></i>
                                </button>
                            </span>
                        </div>
                    </div>

                </div>

            </div>
            <div class="d-flex flex-column clsbidtable mt-3">
                <div class="moving-cart-items">
                    <div class="cart-heading mb-2">
                        <div class="col-md-2">
                            <p>Ticket No.</p>
                        </div>
                        <div class="col-md-2">
                            <p>Ticket Category </p>
                        </div>
                        <div class="col-md-3">
                            <p>Message</p>
                        </div>
                        <div class="col-md-1">
                            <p> Date</p>
                        </div>
                        <div class="col-md-4">
                            <p>Ticket status</p>
                        </div>

                    </div>
                    <div class="cart-data d-flex pointer" *ngFor="let item of ticketList">
                        <div class="text-data col-md-2">
                            <p class=" no-margin-top">
                                {{item.ticketNo}}
                            </p>
                        </div>
                        <div class="col-md-2">
                            <p class=" no-margin">
                                {{item.category}}
                            </p>

                        </div>

                        <div class="col-md-3">
                            <p class=" no-margin-top">
                                {{item.message}}
                            </p>
                        </div>
                        <div class="col-md-1">
                            <p class=" no-margin mt-1">
                                {{item.createdAt | date:'longDate'}}
                            </p>
                        </div>
                        <div class="col-md-4 d-flex">
                            <div class="col-md-3 p-0">
                                <p class=" no-margi-top ">
                                    <img [src]="item.status == 'Open' || item.status == 'open' ? 'assets/svg/open.svg': 'assets/svg/Closed.svg' "
                                        alt="">
                                </p>
                            </div>
                            <div class="col-md-3 p-0">
                                <p class=" remove">
                                    <i class="fa fa-comment mr-1" aria-hidden="true"></i>
                                    <a (click)="gotoAddComment(item._id)">Comment</a>
                                </p>
                            </div>
                            <div class="col-md-3 p-0" *ngIf="item.createdBy == loginUserId">
                                <p class=" remove">
                                    <i class="fa fa-edit mr-1" aria-hidden="true"></i>
                                    <a (click)="gotoupdateticket(item._id)">Update</a>
                                </p>
                            </div>
                            <div class="col-md-3 p-0 pull-right" *ngIf="item.createdBy == loginUserId">
                                <p class=" remove">
                                    <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                                    <a (click)="gotodeleteticket(item._id)">Delete</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="pagination-list ">
                        <div class="pointer ">
                            <img class="previous" src="assets/svg/Left box.svg"
                                [ngClass]="activeFirstPage? 'emptyData' : 'data'" (click)="previouspage()">
                        </div>
                        <div class="number pointer ">
                            <h6>{{activePage}}</h6>
                        </div>
                        <div class="pointer ">
                            <img class="next" src="assets/svg/Right Box.svg" [ngClass]="noData? 'emptyData':'data'"
                                (click)="nextPage()">
                        </div>
                    </div>
                    <div class="text">Showing {{ticketList.length}} tickets of {{activeTotal}} Total tickets</div>
                </div>
            </div>
        </div>
    </div>
</div>